import styled from '@emotion/styled'

import { JanusLayoutRatio } from './Janus'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { breakpoint } from '../../__styling/style-functions'
import { colors } from '../../__styling/settings/colors'
import { themedValue } from '../../__styling/themed-value'
import { ThemeMargins } from '../../__styling/settings/metrics'

/* eslint-disable no-redeclare */
function layoutRatioToValue(
    ratio: JanusLayoutRatio,
): [string, string]
function layoutRatioToValue(ratio: JanusLayoutRatio): any {
    switch (ratio) {
        case '3:1':
            return '3fr 1fr'
        case '1:3':
            return '1fr 3fr'
        case '2:3':
            return '2fr 3fr'
        default:
            return 'repeat(2, 1fr)'
    }
}

export interface JanusBreakpointOptions {
    // Used to specify the layout ratios breakpoint for thewest
    layoutRatiosBreakpoint: 'xs' | 'md'
}

export interface StyledJanusProps {
    hasBackgroundFill?: boolean
    verticalSpacing?: keyof ThemeMargins | undefined
    layoutRatio?: JanusLayoutRatio
    breakpoints?: JanusBreakpointOptions
}

export const StyledJanus = styled('div')<StyledJanusProps>((
    {
        theme,
        verticalSpacing,
        hasBackgroundFill,
        layoutRatio = '1:1',
        breakpoints
    }) =>
    ({
        margin: '0 auto',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '100%',
        gridGap: calcRem(theme.margins.gridGap),
        backgroundColor: hasBackgroundFill ? colors.white : undefined,
        marginBottom:
            verticalSpacing && calcRem(theme.margins[verticalSpacing]),

        [breakpoint('xs')]: {
            gridTemplateColumns: themedValue(theme, {
                thewest: undefined,
                fallback: layoutRatioToValue(layoutRatio),
            }),
        },

        [breakpoint(
            (breakpoints && breakpoints.layoutRatiosBreakpoint) || 'md',
        )]: {
            gridTemplateColumns: themedValue(theme, {
                thewest: layoutRatioToValue(layoutRatio),
                fallback: undefined,
            }),
        },
    }),
)

export const StyledGridItem = styled('div')({
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column'
})
